/**
 * Issue #666: Unified DiagramGenerator interface.
 *
 * Defines the standard contract every diagram generator must implement,
 * plus supporting types for configuration, analysis summaries, and the
 * generator registry.
 *
 * AST types (ParsedFile, DependencyGraph, CallGraph) live in the API
 * package, so we define minimal stand-in interfaces here that the API
 * types satisfy structurally.
 */
import { z } from 'zod';
// ---------------------------------------------------------------------------
// Generator Configuration
// ---------------------------------------------------------------------------
/**
 * Zod schema for the base configuration all generators accept.
 * Individual generators extend this with their own fields.
 */
export const GeneratorConfigSchema = z.object({
    filePatterns: z.object({
        include: z.array(z.string()),
        exclude: z.array(z.string()),
    }).optional(),
    layout: z.object({
        direction: z.enum(['TB', 'LR', 'BT', 'RL']).optional(),
        algorithm: z.enum(['dagre', 'elk', 'force', 'radial', 'tree']).optional(),
    }).optional(),
    maxNodes: z.number().int().positive().optional(),
});
//# sourceMappingURL=generator.js.map